import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'
import UtmTracker from './components/UtmTracker'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <UtmTracker>
      <App />
    </UtmTracker>
  </React.StrictMode>
)
